









































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { useConfig } from '~/composables';
import { TRACKINGS_ATTRIBUTE_SETS_CATEGORYWARE } from '~/utils/constants/product';
import { ProductForProductPageType } from '~/utils/types/solepro/Product';
import { productContactTrack, productGoToSiteTrack } from '~/helpers/trackings/24orepro/products';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    setup(props) {
        const { product } = props;
        const { config: storeConfig } = useConfig();

        const trackProductContact = (callback) => productContactTrack(props.product, callback);
        const trackGoToSite = (callback) => productGoToSiteTrack(props.product, callback);

        return {
            isSoftware :TRACKINGS_ATTRIBUTE_SETS_CATEGORYWARE[product?.attributeSetName.toLowerCase()] == TRACKINGS_ATTRIBUTE_SETS_CATEGORYWARE['software'],
            email: storeConfig.value.general_contact_email,
            phoneExtended: storeConfig.value.general_contact_phone,
            phone: (storeConfig.value.general_contact_phone||'').replace(/ /g,''),
            trackProductContact,
            trackGoToSite
        }
    },
    methods: {
        goToForm() {
            window.location.href = this.product.agentFormLink
        },
        goToSite() {
            window.location.href = this.product.productSite
        },
        goToEmail() {
            window.location.href = `mailto:${this.email}`;
        }
    }
})
